import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EFeatureFlags } from '@app/shared/enums/feature-flag';
import { FeatureFlagCanActivate } from '@app/shared/services/feature-flag/feature-flag-can-active.guard.service';

const routes: Routes = [
  {
    path: 'notifications-center',
    data: {
      breadcrumb: 'Notifications Center',
      extraLink: '/activity',
    },
    loadChildren: () =>
      import('../admin-station/notifications-center/notifications-center.module').then(
        (m) => m.NotificationsCenterModule
      ),
    canActivate: [FeatureFlagCanActivate],
  },
  {
    path: 'locations',
    data: { breadcrumb: 'Locations' },
    loadChildren: () => import('./work-center/location/location.module').then((m) => m.LocationModule),
    canActivate: [FeatureFlagCanActivate],
  },
  {
    path: 'invoices',
    data: { breadcrumb: 'Invoices' },
    loadChildren: () => import('./work-center/invoice/invoice.module').then((m) => m.InvoiceModule),
    canActivate: [FeatureFlagCanActivate],
  },
  {
    path: 'employers',
    data: { breadcrumb: 'Employers' },
    loadChildren: () => import('./work-center/employer/employer.module').then((m) => m.EmployerModule),
    canActivate: [FeatureFlagCanActivate],
  },
  {
    path: 'patients',
    data: { breadcrumb: 'Patients' },
    loadChildren: () => import('./work-center/patient/patient.module').then((m) => m.PatientModule),
    canActivate: [FeatureFlagCanActivate],
  } ,
  {
    path: 'insurances',
    data: { breadcrumb: 'Insurances' },
    loadChildren: () => import('./work-center/insurance/insurance.module').then((m) => m.InsuranceModule),
    canActivate: [FeatureFlagCanActivate],
  },
  {
    path: 'charge-codes',
    data: { breadcrumb: 'Charge-Codes' },
    loadChildren: () => import('./work-center/chargecode/chargecode.module').then((m) => m.ChargeCodeModule),
    canActivate: [FeatureFlagCanActivate],
  },
  {
    path: 'complaints',
    data: { breadcrumb: 'Complaints' },
    loadChildren: () => import('./work-center/complaint/complaint.module').then((m) => m.ComplaintModule),
    canActivate: [FeatureFlagCanActivate],
  },
  {
    path: 'doctors',
    data: { breadcrumb: 'Doctors' },
    loadChildren: () => import('./work-center/doctor/doctor.module').then((m) => m.DoctorModule),
    canActivate: [FeatureFlagCanActivate],
  }, 
  {
    path: 'payment-codes',
    data: { breadcrumb: 'Payment Codes' },
    loadChildren: () => import('./work-center/paymentcode/paymentcode.module').then((m) => m.PaymentCodeModule),
    canActivate: [FeatureFlagCanActivate],
  },
  {
    path: 'fee-schedules',
    data: { breadcrumb: 'Fee-Schedules' },
    loadChildren: () => import('./work-center/feeschedule/feeschedule.module').then((m) => m.FeescheduleModule),
    canActivate: [FeatureFlagCanActivate],
  },
  {
    path: 'general-ledger-accounts',
    data: { breadcrumb: 'GL Accounts' },
    loadChildren: () => import('./work-center/generalledgeraccounts/generalledgeraccounts.module').then((m) => m.GeneralLedgerAccountsModule),
    canActivate: [FeatureFlagCanActivate],
  },
  {
    path: 'fire',
    data: { breadcrumb: 'Fires' },
    loadChildren: () => import('./work-center/fire/fire.module').then((m) => m.FireModule),
    canActivate: [FeatureFlagCanActivate],
  },
  {
    path: 'orgs',
    data: { breadcrumb: 'Orgs' },
    loadChildren: () => import('./work-center/org/org.module').then((m) => m.OrgModule),
    canActivate: [FeatureFlagCanActivate],
  },
  {
    path: 'users',
    data: { breadcrumb: 'Users' },
    loadChildren: () => import('./work-center/user/users.module').then((m) => m.UsersModule),
    canActivate: [FeatureFlagCanActivate],
  },
  {
    path: 'roles',
    data: { breadcrumb: 'Roles Permissions' },
    loadChildren: () => import('./work-center/role/roles.module').then((m) => m.RolesModule),
    canActivate: [FeatureFlagCanActivate],
  },
  {
    path: 'scheduling',
    data: {
      breadcrumb: 'Scheduling',
      featureFlagModule: EFeatureFlags.SCHEDULING,
    },
    loadChildren: () => import('./work-center/scheduling/scheduling.module').then((m) => m.SchedulingModule),
    canActivate: [FeatureFlagCanActivate],
  },
  {
    path: 'event-log',
    data: { breadcrumb: 'event-log.title' },
    loadChildren: () => import('./work-center/event-log/event-log.module').then((m) => m.EventLogModule),
    canActivate: [FeatureFlagCanActivate],
  },
  {
    path: 'transactions',
    data: { breadcrumb: 'transactions.title' },
    loadChildren: () => import('./work-center/transactions/transactions.module').then((m) => m.TransactionsModule),
    canActivate: [FeatureFlagCanActivate],
  },
  {
    path: 'restrictions',
    data: { breadcrumb: 'restrictions.title' },
    loadChildren: () => import('./work-center/restrictions/restrictions.module').then((m) => m.RestrictionsModule),
    canActivate: [FeatureFlagCanActivate],
  },
  {
    path: 'manage-groups',
    data: { breadcrumb: 'manage-groups.title' },
    loadChildren: () => import('./work-center/manage-groups/manage-groups.module').then((m) => m.ManageGroupsModule),
    canActivate: [FeatureFlagCanActivate],
  },
  {
    path: 'insights',
    data: { breadcrumb: 'insights.title' },
    loadChildren: () => import('./work-center/insights/insight.module').then((m) => m.InsightModule),
    canActivate: [FeatureFlagCanActivate],
  },
  {
    path: 'reports',
    data: { breadcrumb: 'reports.title' },
    loadChildren: () => import('./work-center/reports-module/reports.module').then((m) => m.ReportsModule),
    canActivate: [FeatureFlagCanActivate],
  },
  {
    path: 'dashboards',
    data: { breadcrumb: 'Dashboards' },
    loadChildren: () => import('./work-center/dashboards/dashboards.module').then((m) => m.DashboardsModule),
    canActivate: [FeatureFlagCanActivate],
  },
  {
    path: 'sent-claims',
    data: { breadcrumb: 'Sent Claims' },
    loadChildren: () => import('./work-center/sent-claims/sent-claims.module').then((m) => m.SentClaimsModule),
    canActivate: [FeatureFlagCanActivate],
  },
  {
    path: 'import-conflicts',
    data: { breadcrumb: 'Import Conflicts', permissionKey: 'IMPORT_VIEW' },
    loadChildren: () => import('./work-center/import-conflicts/import-conflicts.module').then((m) => m.ImportConflictsModule),
    canActivate: [FeatureFlagCanActivate],
  },
  {
    path: 'work-categories',
    data: { breadcrumb: 'Work Categories', permissionKey: 'WORKCATEGORY_VIEW' },
    loadChildren: () => import('./work-center/work-categories/work-categories.module').then((m) => m.WorkCategoriesModule),
    canActivate: [FeatureFlagCanActivate],
  },
  {
    path: 'my-worklist',
    data: { breadcrumb: 'My Worklist', permissionKey: 'INVOICE_VIEW' },
    loadChildren: () => import('./work-center/my-worklist/my-worklist.module').then((m) => m.MyWorklistModule),
    canActivate: [FeatureFlagCanActivate],
  },
  {
    path: 'import-history',
    data: { breadcrumb: 'Import History', permissionKey: 'INVOICE_VIEW' },
    loadChildren: () => import('./work-center/import-history/import-history.module').then((m) => m.ImportHistoryModule),
    canActivate: [FeatureFlagCanActivate],
  },
  {
    path: 'settings',
    data: { breadcrumb: 'Settings' },
    loadChildren: () => import('./work-center/settings/settings.module').then((m) => m.SettingsModule),
    canActivate: [FeatureFlagCanActivate],
  },
  {
    path: 'api-keys',
    data: { breadcrumb: 'API Keys' },
    loadChildren: () => import('./work-center/apikeys/apikeys.module').then((m) => m.ApiKeysModule),
    canActivate: [FeatureFlagCanActivate],
  },
  {
    path: 'response-ack',
    data: { breadcrumb: 'Response Ack' },
    loadChildren: () => import('./work-center/response-ack/response-ack.module').then((m) => m.ResponseAckModule),
    canActivate: [FeatureFlagCanActivate],
  },
  {
    path: 'claim-errors',
    data: { breadcrumb: 'Claim Errors' },
    loadChildren: () => import('./work-center/claim-errors/claim-errors.module').then((m) => m.ClaimErrorsModule),
    canActivate: [FeatureFlagCanActivate],
  },
  {
    path: '277-status',
    data: { breadcrumb: '277 Status' },
    loadChildren: () => import('./work-center/status-277/status-277.module').then((m) => m.Status277Module),
    canActivate: [FeatureFlagCanActivate],
  },
  {
    path: 'claim-payments',
    data: { breadcrumb: 'Payments' },
    loadChildren: () => import('./work-center/claim-payments/claim-payments.module').then((m) => m.ClaimPaymentsModule),
    canActivate: [FeatureFlagCanActivate],
  },
  {
    path: 'eob-payments',
    data: { breadcrumb: 'EOB Payments' },
    loadChildren: () => import('./work-center/eob-payments/eob-payments.module').then((m) => m.EobPaymentsModule),
    canActivate: [FeatureFlagCanActivate],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [FeatureFlagCanActivate],
})
export class AdminStationRoutingModule {}
